<template>
  <div>
    <q-toolbar :class="'headerPage'">
      <CiudadSelector v-if="showCiudadSelector" @update="update()" :form_dirty="form_dirty" :disabled="disabled" />
      <q-space></q-space>
      <q-toolbar-title class="h5 titleHeader title">{{
        Title
      }}</q-toolbar-title>
    </q-toolbar>
  </div>
</template>

<script>
import { QToolbar, QToolbarTitle, QSpace } from 'quasar';
import CiudadSelector from '@/components/shared/CiudadSelector.vue';

export default {
  components: {
    QToolbar,
    QToolbarTitle,
    QSpace,
    CiudadSelector
  },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    showCiudadSelector: {
      type: Boolean,
      default: () => false
    },
    form_dirty: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      Title: this.title !== undefined ? this.title : ''
    };
  },
  methods: {
    update () {
      this.$emit('update');
    }
  }
};
</script>

<style lang="scss" scoped>
.headerPage {
  background-color: $azulClaroZ;
  height: 73px;
}
.titleHeader {
  flex: none !important;
  margin-right: 85px;
}
</style>
